import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { QUICK_ACTION_STATE } from "../components/search/dispatchCommand";

// Consume the command before opening the existing form. Replacements preserve
// filters/hash and unrelated state, so Back/Forward cannot replay the action.
export default function useQuickAction(command, onOpen) {
  const location = useLocation();
  const navigate = useNavigate();
  const handledKey = useRef(null);
  const openRef = useRef(onOpen);
  openRef.current = onOpen;

  useEffect(() => {
    if (location.state?.[QUICK_ACTION_STATE] !== command || handledKey.current === location.key) return;
    handledKey.current = location.key;
    const { [QUICK_ACTION_STATE]: consumedCommand, ...state } = location.state;
    navigate({ pathname: location.pathname, search: location.search, hash: location.hash }, {
      replace: true,
      state,
    });
    openRef.current();
  }, [command, location, navigate]);
}
